export default {
  message: {
    success: "成功",
    fail: "失败"
  },
  navbar: {
    language: '语言',
    logOut: '退出登陆', //退出登陆
    submit:'提交', //提交
    label_options:'标签选项', //标签选项
    close_other:'关闭其他', //关闭其他
    close_all:'关闭所有', //关闭所有
  },
  login: {
    title: '客户端登陆',
    logIn: '登陆',
    register:'注册',
  },
  register:{
    title:'注册',
    username:'用户名',
    password:'密码',
    checkPass:'确认密码',
    captcha:'验证码',
    submit:'提交',
    cancel:'取消',
  },
  sidebar:{
    financial:'财务管理',
    accountDetails:'账目明细',
    billingDetails:'账单明细',
    account:'账户管理',
    personalInformation:'个人中心',
    changePassword:'密码修改',
    affiliation:'推广管理',
    earnings:'我的推广',
    payoutRequests:'提现申请',
    payoutList:'提现列表',
    about:'关于'
  },
  account:{
    accountBalance:'账户余额',
    pendingPayment:'已用额度',
    commissionAmount:'佣金金额',
    availableBalance:'剩余金额',
    paymentInformation:'收款银行列表',
    currency:'币种',
    accountName:'账户名称',
    bankAccount:'银行账号',
    bankName:'银行名称',
    bankAddress:'银行地址',
    account:'账目',
    rechargeApplication:'充值申请',
    rechargeAccount:'充值账目',
    paymentAccount:'付款账目',
    applicationAccount:'申请账目',
    rechargeCurrency:'充值币种',
    transactionNumber:'交易编号',
    exchangeRate:'当时汇率',
    amountOfArrival:'到账金额',
    typesOf:'类型',
    remarks:'备注',
    timeOfArrival:'到账时间',
    creationTime:'创建时间',
    status:'状态',
  },
  tradeStatus:{
    waitReview:'等待审核', //等待审核
    success:'交易成功',  //交易成功
    failed:'交易失败', //交易失败
    cancel:'取消交易',  //取消交易
  },
  typeOf:{
    recharge:'充值', //充值
  },
  bill:{
    myBillDetails:'我的账单明细',//我的账单明细
    time:'时间', //时间
    amountOfConsumption:'消费金额(美元)', //消费金额
    consumptionType:'消费类型', //消费类型
    consumptionContent:'消费内容', //消费内容
  },
  personal:{
    accountInformation:'账号信息',  //账号信息
    loginAccount:'登陆账号',  //登陆账号
    userName:'用户名称', //用户名称
    phoneNumber:'手机号码', //手机号码
    personalInformation:'个人信息', //个人信息
    company:'公司', //公司
    companyAddress:'公司地址', //公司地址
    country:'国家', //国家
    area:'省级区域', //省级区域
    city:'城市', //城市
    language:'语音',//语音
  },
  password:{
    changePassword:'修改密码', //修改密码
    enterOldPassword:'输入旧密码', //输入旧密码
    newPassword:'输入新密码', //输入新密码
    confirmNewPassword:'确认新密码', //确认新密码
  },
  http:{
    unauthorized:'未授权，请重新登录',//未授权，请重新登录
  },
  earnings: {
    myLink: "我的推广链接",
    myRegisterLink: "我的注册推广链接",
    message1: "当被推荐人充值时，推荐人将会获得1%的佣金。",
    message2: "此外，如果被推荐人在适用我们的应用程序的前30天重置了对应的金额，推荐人能得到额外的奖金。如下图。",
    message3: "请注意！这是一次性的奖金。并且被推荐人在适用我们的应用程序时，就开始30天的倒计时",
    detailTitle: "我的推广详情",
    column1: "客户ID",
    column2: "客户名称",
    column3: "注册时间",
    column4: "首次佣金时间",
    column5: "今日佣金",
    column6: "七天佣金",
    column7: "30天佣金",
    column8: "累计佣金",
    column9: "奖金",
    column10: "佣金比例",
  },
  payout: {
    totalRevenue:"总收入",
    withdrawn:"已提现",
    withdrawable:"可提现",
    withdrawalApplication:"提现申请"
  },
  payoutList: {
    myWithdrawalList: "我的提现列表",
    column1: "交易单号",
    column2: "提现金额（美元）",
    column3: "提现币种",
    column4: "汇率",
    column5: "实际提现金额",
    column6: "备注",
    column7: "申请时间",
    column8: "完成时间",
    column9: "状态",
  }

}
